<template>
  <div>
    <v-app-bar app color="primary" dark>
      <v-toolbar-title>
        <router-link to="/">
          <img
            width="120"
            src="https://firebasestorage.googleapis.com/v0/b/fattoura-86f56.appspot.com/o/fattoura_logo_white.png?alt=media&token=3ef507a6-3710-4e69-905b-ece8461f8933"
            alt="Fattoura.com"
            height="100%"
          />
        </router-link>
      </v-toolbar-title>

      <p>Beta</p>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn v-if="this.$route.name === 'invoice.preview'" icon @click="backToHome">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-btn
          v-if="this.$route.name === 'invoice.preview' || this.$route.name === 'invoice.show'  "
          icon
          @click="print"
        >
          <v-icon>mdi-printer</v-icon>
        </v-btn>
        <v-btn :disabled="$store.state.buttons.save" v-if="this.$route.name === 'invoice.preview'" @click="saveInvoice" icon>
          <v-icon>mdi-floppy</v-icon>
        </v-btn>
        <v-btn
          v-if="$store.state.user === undefined || $store.state.user === null || !$store.state.avatar.show"
          @click="$router.push('/login')"
          text
        >{{$t('app.signin')}}</v-btn>
        <v-menu top close-on-click v-if="$store.state.avatar.show">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text>
              <v-avatar>
                <img :src="$store.state.avatar.url" />
              </v-avatar>
            </v-btn>
          </template>

          <v-list>
               <v-list-item @click="$router.push('/profile')">
              <v-icon>mdi-account-settings</v-icon>
              {{$t('app.my_profile')}}
            </v-list-item>
            <v-list-item @click="$router.push('/dashboard')">
              <v-icon>mdi-send</v-icon>
              {{$t('app.sent')}}
            </v-list-item>
               <v-list-item @click="$router.push('/received')">
              <v-icon>mdi-email-receive</v-icon>
              {{$t('app.received')}}
            </v-list-item>
            <v-list-item @click="signOut">
               <v-icon>mdi-logout-variant</v-icon>
              {{$t('app.signout')}}</v-list-item>
          </v-list>
        </v-menu>
        <v-menu top close-on-click>
          <template v-slot:activator="{ on }">
            <v-btn dark v-on="on" text>
              <flag :iso="selectedLang" v-bind:squared="false" />
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              @click="selectLang(lang)"
              :key="lang.flag"
              v-for="lang in $t('app.languages')"
            >
              <flag :iso="lang" v-bind:squared="false" />
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import i18n from "../plugins/i18n";
import { db } from "../firebase";
import { firebase } from "@firebase/app";
import "@firebase/firestore";
import "@firebase/auth";

export default {
  name: "Navbar",
  components: {},
  data: () => ({
 
    selectedLang: "us",
    languages: [
      { flag: "us", language: "en", title: "English" },
      { flag: "fr", language: "fr", title: "Frensh" }
    ]
  }),
  computed: {
    ...mapState(["invoice", "showNavActionButtons"])
  },
  methods: {
    ...mapActions(["toogleNavbarAction", "updateModal", "setUser", "logout","setSaveButtonStatus"]),
    signOut() {
      this.logout();
      this.$router.push("/login");
    },
    selectLang(l) {
      this.$i18n.locale = l;
      this.selectedLang = l;
      firebase.auth().languageCode = l;
    },
    saveInvoice() {
    this.setSaveButtonStatus(true)
      this.invoice.user_id = firebase.auth().currentUser.uid;
      db.collection("userInvoices")
        .add({
          invoice: this.invoice
        })
        .then(r => {
          let url = process.env.VUE_APP_BASE_APP_URL + "#/show/" + r.id;
          let modal = {
            title: this.$t("app.share"),
            content: this.$t("app.share_message"),
            url: url,
            type: "url"
          };
          this.updateModal(modal);
        });
    },
    changeLang() {
      i18n.locale = this.selectedLang;
    },
    backToHome() {
      this.toogleNavbarAction();
      this.$router.push("/app");
    },
    print() {
      window.print();
    }
  },
  mounted() {
    let host = window.location.hostname.split(".")
   if(host.length === 3 &&  host[0] === "fr"){
    i18n.locale = "fr"
    this.selectedLang = "fr"
    firebase.auth().languageCode = "fr";

   }else{
    i18n.locale = "us"
      this.selectedLang = "us"
    firebase.auth().languageCode = "en";

   }
  }
};
</script>
<style  scoped>
@media print {
  header {
    height: 0 !important;
    display: none !important;
  }
}
</style>
